<template>
  <div class="app-container">
    <el-button type="primary" @click="exportToExcel()">匯出到Excel</el-button>
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="老師編號" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="老師姓名" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="應付總計(家教課)" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.tutor }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="應付總計(團體課)" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.group }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="record(scope.row.number, scope.row.name, scope.row.list)">詳細紀錄</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <RecordDialog :dialog-record-visible-prop="dialogRecordVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import RecordDialog from '@/views/billings/counts/record'
import BillingResource from '@/api/billing'
import { param } from '@/utils'
import request from '@/utils/request'

const billingResource = new BillingResource()

export default {
  name: 'TeacherCreditCountList',
  components: { Pagination, RecordDialog },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        role: 'teacher'
      },
      dialogRecordVisible: false,
      currentRecordNumber: '',
      currentRecordName: '',
      currentRecordList: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await billingResource.getPayableList(this.listQuery)
      console.log(data)
      this.list = data.items
      this.total = data.total
      this.listLoading = false
    },
    record(number, name, list) {
      this.currentRecordNumber = number
      this.currentRecordName = name
      this.currentRecordList = list
      this.dialogRecordVisible = true
    },
    exportToExcel() {
      var p = param(this.listQuery);
      var url = "/api/v1/billings/payable/excel?" + p;
      request({
        url: url,
        method: 'get',
        responseType: 'blob'
      }).then((blob) => {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "teachers_payable.xlsx";
        link.click()
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
